import { OnSpotContactData, OnSpotFileLists, OnSpotReturnTree } from '../../model/onSpot/OnSpot';
import { buildApiUrl } from '@/_helper/apiHelper';

const getOnSpotTree = async (params: URLSearchParams) => {
    const endpoint = `/onSpot/get?${params.toString()}`;

    return fetch(buildApiUrl(window.$serviceUrl, endpoint), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    })
        .then(async (response) => {
            if (!response.ok) {
                return Promise.reject();
            }
            return await response.json();
        })
        .catch(() => {
            return Promise.reject();
        });
};

const saveOnSpotTree = async (
    onSpotReturnData: OnSpotReturnTree,
    bookingNumber: string,
    contactData: OnSpotContactData,
    fileCount: number
) => {
    const data = {
        customerAnswerTree: onSpotReturnData,
        contactData: {
            mail: contactData.mail,
            phoneNumber:
                contactData.mobile.phoneCountryPrefix +
                contactData.mobile.phoneAreaCode +
                contactData.mobile.phoneNumber,
        },
        fileCount: fileCount,
    };

    return fetch(buildApiUrl(window.$serviceUrl, `/onSpot/save?bookingNumber=${bookingNumber}`), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then(async (response) => {
            if (response.ok) {
                return Promise.resolve();
            } else {
                return Promise.reject();
            }
        })
        .catch(() => {
            return Promise.reject();
        });
};
const saveFile = async (data: FormData) => {
    return fetch(buildApiUrl(window.$serviceUrl, '/onSpot/saveFile'), {
        method: 'POST',
        body: data,
    })
        .then(async (response) => {
            if (!response.ok) {
                return Promise.reject();
            }
            return Promise.resolve(response);
        })
        .catch(() => {
            return Promise.reject();
        });
};

const saveFiles = async ({ fileLists, bookingNumber }: { fileLists: OnSpotFileLists; bookingNumber: number }) => {
    return fetch(buildApiUrl(window.$serviceUrl, '/onSpot/purgeUploadFolder'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bookingNumber }),
    })
        .then((response) => (response.ok ? Promise.resolve() : Promise.reject()))
        .then(() => {
            let promises = [];
            if (fileLists) {
                for (const fileList of Object.keys(fileLists)) {
                    for (const fileData of fileLists[fileList]) {
                        const formData = new FormData();
                        formData.set('bookingNumber', bookingNumber.toString());
                        formData.set('category', fileData.category.toString());
                        fileData.subCategory && formData.set('subcategory', fileData.subCategory.toString());
                        formData.set('documentType', fileData.documentType);
                        formData.set('file', fileData.file);

                        promises.push(
                            saveFile(formData)
                                .then((response) => {
                                    if (response) {
                                        return Promise.resolve(true);
                                    } else {
                                        return Promise.reject(false);
                                    }
                                })
                                .catch(() => {
                                    return Promise.reject('error');
                                })
                        );
                    }
                }
            }
            return Promise.all(promises);
        })
        .catch(() => {
            return Promise.reject();
        });
};

const OnSpotApi = {
    getOnSpotTree,
    saveOnSpotTree,
    saveFile,
    saveFiles,
};

export default OnSpotApi;
